import { computed } from 'vue'
import useBusinessStore from '@/stores/useBusiness'
import useUserStore from '@/stores/useUserStore'
import {
  AGENCY_PAID_MAX_BRANDS,
  FREE_AGENCY_MAX_BRANDS,
  PRODUCT_MAX_BRANDS,
} from '@/constants/brandLimits'

export function useBrandLimits() {
  const businessStore = useBusinessStore()
  const userStore = useUserStore()

  const hasPaidAgencySubscription = computed(() => {
    const type =
      userStore.subscriptionData?.subscriptionType ?? userStore.userProfile?.subscriptionType
    const status =
      userStore.subscriptionData?.subscriptionStatus ?? userStore.userProfile?.subscriptionStatus
    return type === 'agency' && status === 'active'
  })

  const maxBrands = computed(() => {
    if (businessStore.brandLimit?.maxBrands != null) {
      return businessStore.brandLimit.maxBrands
    }

    if (businessStore.businessType === 'agency') {
      return hasPaidAgencySubscription.value ? AGENCY_PAID_MAX_BRANDS : FREE_AGENCY_MAX_BRANDS
    }

    return PRODUCT_MAX_BRANDS
  })

  const currentBrands = computed(() => {
    if (businessStore.brandLimit?.currentBrands != null) {
      return businessStore.brandLimit.currentBrands
    }

    return businessStore.brands.length
  })

  const canAddBrand = computed(() => {
    if (businessStore.brandLimit != null) {
      return businessStore.brandLimit.canAddBrand
    }

    return currentBrands.value < maxBrands.value
  })

  const isAgencyFreeLimit = computed(
    () => businessStore.businessType === 'agency' && maxBrands.value === FREE_AGENCY_MAX_BRANDS
  )

  return {
    maxBrands,
    currentBrands,
    canAddBrand,
    hasPaidAgencySubscription,
    isAgencyFreeLimit,
  }
}
